import decoder from '../../../lib/decoder';

function ModelCategory(code, name) {
	this.code = code || '';
	this.name = name || '';
	this.count = 0;
}

ModelCategory.constants = {
	code: {
		usual: 'usual',
		silver: 'silver',
		gold: 'gold',
		platinum: 'platinum',
		exclusive: 'exclusive'
	}
};

ModelCategory.create = function (json) {
	if (!json) json = {};
	
	let model = new ModelCategory();
	
	model.code = decoder.stringValue(json['code'], '');
	model.name = decoder.stringValue(json['name'], '');
	model.count = decoder.intValue(json['count'], 0);
	
	return model;
};

export default ModelCategory;